import React from 'react';

import { ALLOWED_ROLES } from '@src/packages/utils/access';

import { PATHS } from './constants';

const OptionLists = React.lazy(() => import('./screens/OptionLists'));

const routes = [
  {
    component: OptionLists,
    path: PATHS.BASE_URL,
    exact: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.OPTION_LISTS.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
];

export default routes;
